import { render, staticRenderFns } from "./TemplateGalery.vue?vue&type=template&id=35bc4e47&scoped=true"
import script from "./TemplateGalery.vue?vue&type=script&lang=js"
export * from "./TemplateGalery.vue?vue&type=script&lang=js"
import style0 from "./TemplateGalery.vue?vue&type=style&index=0&id=35bc4e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc4e47",
  null
  
)

export default component.exports